
export enum ProjectTool {
  Designer = 'designer-2',
  Mattercraft = 'mattercraft-beta',
  UniversalAR = 'uar',
}

export enum IProjectTemplateCategories {
  Image = 'image',
  World = 'world',
  Face = 'face',
  Content360 = '360'
}
export enum ProjectToolSdk{
  Mattercraft = 'mattercraft-local',
  PlayCanvas = 'playcanvas',
  Unity = 'unity',
  JavaScript = 'javascript',
  AFrame = 'a-frame',
  BabylonJs	= 'babylonjs',
  ReactThreeJs = 'react-three-js',
  ThreeJs = 'three-js	'
}

export const PROJECT_TEMPLATE_CATEGORIES = [IProjectTemplateCategories.Image, IProjectTemplateCategories.World, IProjectTemplateCategories.Face, IProjectTemplateCategories.Content360];
